import {useEffect, useRef, useState} from 'react';
import strapiDao from '../../dao/strapiDao';
import StrapiUtils from './strapiUtils';
import langCode from '../../utils/langCode';
import {useTranslation} from 'react-i18next';
import _isObject from 'lodash/isObject';
import _get from 'lodash/get';
import webUtils from '../../utils/webUtils';
import demostoreUtils from '../../utils/demostoreUtils';

export default function GetStrapiContent(
  type,
  setIsLoaded,
  location,
  defaultEnu = false,
  isDynamic = false,
  useDefaultVersion = false
) {
  const pageKey = window.location.pathname.slice(
    window.location.pathname.lastIndexOf('/') + 1
  );
  const formIdRef = useRef('');
  const [pfFormId, setPfFormId] = useState('');
  const {t, i18n} = useTranslation();
  const params = new URLSearchParams(location.search);
  const [functionKey, setFunctionKey] = useState('');
  const [strapiContent, setStrapiContent] = useState([]);
  const [seo, setSeo] = useState({});
  const languageType = langCode.convertLanguageCode(i18n.language || 'en');
  const isEnd = webUtils.isEndLanguage(languageType);
  const cmsId = params.get('cmsId');
  useEffect(() => {
    const handler = event => {
      if (demostoreUtils.isDemostore() && !webUtils.isMsrFormPreview()) return;
      if (!_get(event, 'data') || _isObject(event.data)) return;

      const formId = event.data;

      if (formIdRef.current !== formId) {
        formIdRef.current = formId;
        setPfFormId(formId);
        window.removeEventListener('message', handler);
      }
    };

    window.addEventListener('message', handler);
    return () => {
      window.removeEventListener('message', handler);
    };
  }, []);
  useEffect(() => {
    if (
      type === 'YOU_CAM_VIDEO' &&
      window.location.pathname.indexOf('ycv') === -1
    ) {
      return;
    }
    if (cmsId && !useDefaultVersion) {
      strapiDao
        .getProductPageById({
          type: type,
          id: cmsId,
        })
        .then(res => {
          if (!res) return;
          setStrapiContent(StrapiUtils.SectionCombine(res.attributes));
          setFunctionKey(_get(res, 'attributes.functionKey', ''));
          if (_get(res, 'attributes.seo')) {
            setSeo(_get(res, 'attributes.seo'));
          }
          setIsLoaded(true);
        })
        .catch(err => {
          console.log({err});
        });
      return;
    }
    strapiDao
      .getProductPageByLanguage(
        {
          type: type,
          languageType: isEnd ? 'end' : languageType,
          defaultEnu: isEnd || defaultEnu,
          ...(isDynamic && {pageKey}),
        },
        pfFormId
      )
      .then(res => {
        if (res) {
          setStrapiContent(StrapiUtils.SectionCombine(res.attributes));
          setFunctionKey(_get(res, 'attributes.functionKey', ''));
        }
        if (_get(res, 'attributes.seo')) {
          setSeo(_get(res, 'attributes.seo'));
        }
        setIsLoaded(true);
      })
      .catch(err => {
        console.log({err});
      });
  }, [languageType, pfFormId]);

  return {strapiContent, seo, functionKey};
}
